import(/* webpackMode: "eager" */ "/vercel/path0/components/sections/brand-marquee.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/sections/capabilities-bento.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/sections/cta-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerSegments"] */ "/vercel/path0/components/sections/customer-segments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/components/sections/hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/sections/news-grid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/sections/services-search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsCounter"] */ "/vercel/path0/components/sections/stats-counter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/sections/testimonials.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.4_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react_dc2e9969dae164b8404cb231b114ccba/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.4_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react_dc2e9969dae164b8404cb231b114ccba/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
